import { useEffect } from 'react';
import useLocalStorage from '../../utils/services/localStorage/useLocalStorage';
import localStorageService from '../../utils/services/localStorage/localStorage';
import globalLogger from '../../logger/logger';

const logger = globalLogger.createChannel('mobileWorkspaceRestoreMode');

export enum MobileWorkspaceRestoreMode {
    YOUR_BOARDS = 'yourBoards',
    QUICK_NOTES = 'quickNotes',
}

export const RESTORE_MODE_KEY = 'milanote.mobile.restoreMode';

export const clearMobileWorkspaceRestoreMode = () => localStorageService.removeItem(RESTORE_MODE_KEY);
export const getMobileWorkspaceRestoreMode = (): string | undefined => {
    const item = localStorageService.getItem(RESTORE_MODE_KEY);

    if (!item) return undefined;

    try {
        return JSON.parse(item);
    } catch (e) {
        // Sensitive data audit: SAFE — Parse error for restore mode setting, no user data
        logger.error('Failed to parse mobile workspace restore mode', e);
    }

    return undefined;
};

/**
 * Stores the current workspace restore mode in local storage.
 * This will be used on root redirection to return to the quick notes or workspace if necessary.
 */
export const useMobileWorkspaceRestoreMode = (isCurrentBoardQuickNotes: boolean) => {
    const [_, setRestoreMode] = useLocalStorage(RESTORE_MODE_KEY, MobileWorkspaceRestoreMode.YOUR_BOARDS);

    useEffect(() => {
        const restoreMode = isCurrentBoardQuickNotes
            ? MobileWorkspaceRestoreMode.QUICK_NOTES
            : MobileWorkspaceRestoreMode.YOUR_BOARDS;
        setRestoreMode(restoreMode);
    }, [isCurrentBoardQuickNotes]);
};
